import React from 'react';
import { Route, Redirect } from 'react-router';

import LoadingSwitch from 'lib/react-router/loading-switch';
import RouteWithSearch from 'lib/react-router/route-with-search';
import ScrollToTop from 'lib/scroll/scroll-to-top';

import PostLoader from 'four-nets/photoblog/posts/short-post/detail/post-loader';
import UserBlog from 'four-nets/photoblog/user-blog/user-blog';
import AlbumImagesEdit from 'four-nets/photoblog/posts/album/edit/images-edit/images-edit';
import AlbumImagesReorder from 'four-nets/photoblog/posts/album/edit/images-reorder/images-reorder';
import AlbumInfoEdit from 'four-nets/photoblog/posts/album/edit/info-edit/info-edit';
import AlbumDetailLoader from 'four-nets/photoblog/posts/album/detail/detail-loader';

import Article from 'four-nets/photoblog/article/article';
import ImageLoader from 'four-nets/photoblog/image/image-loader';
import NotFound from 'four-nets/errors/404/not-found';

import PhotoBlog, { PhotoBlogSections } from './photoblog';
import CreateEditArticle from './create-edit-article/create-edit-article';
import ArticleEditLoader from './create-edit-article/edit-loader';
import CollectionsRouter from './collections/collections-router';
import PopularImagesWrapper from './popular-images/popular-images-wrapper';
import InspirationsRouter from './inspirations/inspirations-router';
import Confirmation from './friendship/accept';

const sectionsRegex = PhotoBlogSections.join('|');

class PhotoBlogRouter extends React.PureComponent {
    render() {
        return (
            <>
                <ScrollToTop />
                <LoadingSwitch>
                    <Route path='/friends/confirm/:confirmationKey' exact={true} component={Confirmation} />
                    <RouteWithSearch path='/blog/:username/collection' component={CollectionsRouter} />
                    <RouteWithSearch path='/blogs/collections' component={CollectionsRouter} />
                    <RouteWithSearch path='/blog/:username/add/article' exact={true} component={CreateEditArticle} />
                    <RouteWithSearch
                        path='/blog/:username/article/:slug/edit'
                        exact={true}
                        component={ArticleEditLoader}
                    />
                    <RouteWithSearch path='/blog/:username/article/:slug' exact={true} component={Article} />
                    <Redirect
                        from='/fotoblog/:username/article/:slug'
                        to='/blog/:username/article/:slug'
                        exact={true}
                    />
                    <RouteWithSearch path='/blog/:username/album/:slug/edit' exact={true} component={AlbumInfoEdit} />
                    <RouteWithSearch
                        path='/blog/:username/album/:slug/edit-photos'
                        exact={true}
                        component={AlbumImagesEdit}
                    />
                    <RouteWithSearch
                        path='/blog/:username/album/:slug/reorder'
                        exact={true}
                        component={AlbumImagesReorder}
                    />
                    <Redirect
                        from='/fotoblog/:username/article/:slug/edit'
                        to='/blog/:username/article/:slug/edit'
                        exact={true}
                    />
                    <Route path='/blog/:username/album/:slug/:imageId(\d+)' exact={true} component={ImageLoader} />
                    <Route path='/blog/:username/message/:slug?/:imageId(\d+)' exact={true} component={ImageLoader} />
                    <Redirect
                        from='/fotoblog/:username/album/:slug/:imageId'
                        to='/blog/:username/album/:slug/:imageId'
                        exact={true}
                    />
                    <RouteWithSearch path='/blog/:username/album/:slug' exact={true} component={AlbumDetailLoader} />
                    <Redirect from='/fotoblog/:username/album/:slug' to='/blog/:username/album/:slug' exact={true} />
                    <RouteWithSearch path='/blog/:username/:type?/:slug?/:imageId?' exact={true} component={UserBlog} />
                    <Redirect
                        from='/fotoblog/:username/:type?/:slug?/:imageId?'
                        to='/blog/:username/:type?/:slug?/:imageId?'
                        exact={true}
                    />
                    <Route path='/inspirations' component={InspirationsRouter} />
                    <RouteWithSearch path='/blogs/post/:id' exact={true} component={PostLoader} />
                    <RouteWithSearch path={`/blogs/:section(${sectionsRegex})`} exact={true} component={PhotoBlog} />
                    <RouteWithSearch
                        exact={true}
                        path='/blogs/staff-picks'
                        render={(props: any) => <PhotoBlog onlyStaffPicks={true} {...props} />}
                    />
                    <Route path='/blogs/popular' exact={true} component={PopularImagesWrapper} />
                    <RouteWithSearch path='/blogs' exact={true} component={PhotoBlog} />
                    <Redirect from='/profile/*' to='/blog/*' />
                    <Route component={NotFound} />
                </LoadingSwitch>
            </>
        );
    }
}

export default PhotoBlogRouter;
